import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchPageTermThunk, searchTermThunk } from "./search.actions";

export const searchTerm = createAsyncThunk(
  "search/searchTerm",
  searchTermThunk
);

export const searchPageTerm = createAsyncThunk(
  "search/searchPageTerm",
  searchPageTermThunk
);

export const searchInitialState = {
  searchTermInput: "",
  searchForm: {
    is_loading: false,
    is_fetch: false,
    error: false,
    data: {
      article_categories: [],
      articles: [],
    },
  },
  searchPage: {
    is_loading: false,
    is_fetch: false,
    error: false,
    data: {
      article_categories: [],
      articles: [],
    },
    meta: {
      // page: 0,
      // take: 0,
      // item_count: 0,
      // page_count: 0,
      // has_previous_page: true,
      // has_next_page: true,
    },
  },
};

const SearchSlice = createSlice({
  name: "search",
  initialState: searchInitialState,
  reducers: {
    setSearchTermInput: (state, { payload }) => {
      return { ...state, searchTermInput: payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchTerm.fulfilled, (state, { payload }) => {
        return {
          ...state,
          searchForm: {
            is_loading: false,
            is_fetch: true,
            data: payload,
            error: false,
          },
        };
      })
      .addCase(searchTerm.pending, (state) => {
        return {
          ...state,
          searchForm: {
            is_loading: true,
            is_fetch: false,
            data: {
              article_categories: [],
              articles: [],
            },
            error: false,
          },
        };
      })
      .addCase(searchTerm.rejected, (state) => {
        return {
          ...state,
          searchForm: {
            error: true,
            is_fetch: false,
            is_loading: false,
            data: {
              article_categories: [],
              articles: [],
            },
          },
        };
      })
      .addCase(searchPageTerm.fulfilled, (state, { payload }) => {
        return {
          ...state,
          searchPage: {
            is_loading: false,
            is_fetch: true,
            data: payload.data,
            error: false,
            meta: payload.meta,
          },
        };
      })
      .addCase(searchPageTerm.pending, (state) => {
        return {
          ...state,
          searchPage: {
            is_loading: true,
            is_fetch: false,
            data: {
              article_categories: [],
              articles: [],
            },
            error: false,
            meta: {},
          },
        };
      })
      .addCase(searchPageTerm.rejected, (state) => {
        return {
          ...state,
          searchPage: {
            is_loading: false,
            is_fetch: false,
            data: {
              article_categories: [],
              articles: [],
            },
            error: true,
            meta: {},
          },
        };
      });
  },
});
export const { setSearchTermInput } = SearchSlice.actions;
export default SearchSlice.reducer;
